import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';

export type AppProps = RouteConfigComponentProps & {};

export function App({ route }: AppProps) {
  return <>{route && renderRoutes(route.routes)}</>;
}
